import { SIZES_SORT_ORDER } from '@srcDS/js/components/organisms/productActions/utils/sortOrder';
import { Term } from '../Filter';

export const sortedFacetsTerm = (attributeId: string, terms: Term[]): Term[] => {
  if (attributeId === 'variants.attributes.refinementcolour') return terms.map((term) => ({ ...term, isColor: true }));

  if (attributeId !== 'variants.attributes.size') return terms;

  return (
    terms?.sort((a, b) => SIZES_SORT_ORDER.indexOf(String(a.name)) - SIZES_SORT_ORDER.indexOf(String(b.name))) || []
  );
};
